import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import Modal from '@qc/particle/lib/components/modal'
import React, { CSSProperties, ReactNode, useContext } from 'react'
import GlobalNavPopupContext, { PopupType } from '../PopupContext'
import ActionIcon from './navactions/ActionIcon'

export interface Props {
    icon?: IconDefinition
    iconHover?: IconDefinition
    type: PopupType
    modalClassName?: string
    children?: ReactNode
    width: number
    'data-cy'?: string
    onClose?: (event: React.MouseEvent) => void
    actionIconChildren?: React.ReactNode
    actionIcon?: React.ReactNode
    offset?: number
    offsetType?: 'left' | 'right'
    className?: string
}

export const Dropdown = (props: Props) => {
    const {
        offsetType= 'right',
        type,
        className,
        actionIcon,
        actionIconChildren,
        icon,
        iconHover,
        modalClassName,
        width,
        offset
    } = props
    const popupContext = useContext(GlobalNavPopupContext)
    const isOpen = popupContext.openPopup === props.type
    const handleClose = (event: React.MouseEvent) => {
        if (props.onClose) props.onClose(event)
        popupContext.setOpenPopup(null)
    }
    const style: CSSProperties = {
        top: '60px',
        left: `calc(100vw - ${width + (offset || 1)}px)`,
        margin: 0,
        position: 'relative'
    }
    if (offsetType === 'left') {
        style.left = `${(offset || 1)}px`
    }
    return (
        <div className={className}>
            {actionIcon ? <div onClick={() => popupContext.setOpenPopup(type)}>
                {actionIcon}
            </div> : <ActionIcon
                selected={isOpen}
                icon={icon}
                iconHover={iconHover}
                onClick={() => popupContext.setOpenPopup(type)}
                data-cy={props['data-cy'] + 'Btn'}
                style={isOpen ? { zIndex: 1001 } : null}
            >
                {actionIconChildren}
            </ActionIcon>}
            <Modal
                wrapClassName={'gn_particle_base'}
                className={modalClassName}
                transitionName="" // Transitions disabled intentionally to provide a faster UX experience for the user.
                maskTransitionName=""
                visible={isOpen}
                data-cy={props['data-cy']}
                onCancel={handleClose}
                closable={false}
                closeIcon={null}
                maskClosable={true}
                centered={false}
                style={style}
                bodyStyle={{ padding: 0 }}
                width={width}
                footer={null}
            >
                {props.children}
            </Modal>
        </div>
    )
}
